module.exports = __webpack_public_path__ + "static/media/wush_logo.34c0eeef.png";